import { render, staticRenderFns } from "./Canoe.vue?vue&type=template&id=36036a45&"
import script from "./Canoe.vue?vue&type=script&lang=js&"
export * from "./Canoe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports